import React, { memo } from 'react';
import { find, get } from 'lodash';
import { PieChart } from 'react-minimal-pie-chart';
import {
  CHARGER_STATUS_ALERT,
  CHARGER_STATUS_AVAILABLE,
  CHARGER_STATUS_MONITORED,
  CHARGER_STATUS_PARTIALLY_OOS,
  CHARGER_STATUS_TOTALLY_OOS,
  CHARGER_STATUS_UNKNOWN,
  chargerStatuses,
} from '../../../../common/constants/statuses';

const pointsKeys = [
  CHARGER_STATUS_AVAILABLE,
  CHARGER_STATUS_PARTIALLY_OOS,
  CHARGER_STATUS_ALERT,
  CHARGER_STATUS_MONITORED,
  CHARGER_STATUS_TOTALLY_OOS,
  CHARGER_STATUS_UNKNOWN,
];

function PieChartWrapper(props) {
  const {
    clusterStyles, text, pointsData, onPieChartClick,
  } = props;

  return (
    <div
      onMouseDown={onPieChartClick}
      onTouchStart={onPieChartClick}
      className="cluster-marker"
      style={{ transform: 'translate3D(0,0,0)', ...clusterStyles }}
    >
      <div className="cluster-pie-chart">
        <PieChart
          data={
            pointsKeys.map((pointKey, index) => ({
              value: get(pointsData, pointKey),
              key: index + 1,
              color: pointKey === CHARGER_STATUS_UNKNOWN ? '#808080' : find(chargerStatuses, { key: pointKey }).color,
            }))
          }
        />
      </div>
      <div className="cluster-text">
        {text}
      </div>
    </div>
  );
}

export default memo(PieChartWrapper);
